import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {Box} from '@primer/react'

export const HeaderLoading = () => {
  return (
    <>
      <Box sx={{display: 'flex', justifyContent: 'space-between', marginBottom: 2}}>
        <LoadingSkeleton variant="rounded" height="xl" width="400px" />
      </Box>
      <Box sx={{display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 2, marginBottom: 3}}>
        <LoadingSkeleton variant="pill" height="xl" width="77px" />
        <LoadingSkeleton variant="rounded" height="lg" width="200px" />
      </Box>
    </>
  )
}

try{ HeaderLoading.displayName ||= 'HeaderLoading' } catch {}